import React, { FC, useMemo } from 'react';
import TracPage from '@services/tracpage/types/trac-page';
import { ContentGrid } from '@shared-tracpage/components/content-grid';
import { HomeWrapperItems } from '@shared-tracpage/components/home-wrapper-items';
import { List } from '@shared-tracpage/components/list';
import { SongLink } from '@shared-tracpage/components/song-link';
import AppState from '@webapp/store/state';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { groupMusicByVisibility } from '@shared-tracpage/utils/group-by-visibility';
import { TracPageLink } from '@services/tracpage/types/trac-page-link';

type StateProps = {
  pageData: TracPage;
  dspsMap: Record<string, TracPageLink[]>;
};
type DispatchProps = {};
type Props = StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => ({
  pageData: state.tracpage.artistPageDraft,
  dspsMap: state.tracpage.dspsMap,
});

const mapDispatchToProps = (_dispatch: Dispatch): DispatchProps => ({});

const MusicPage: FC<Props> = ({ pageData, dspsMap }) => {
  const { visible, hidden } = useMemo(
    () => groupMusicByVisibility(pageData),
    [pageData]
  );

  return (
    <>
      <HomeWrapperItems>
        <ContentGrid noEditUI title="Music">
          <List gap="small">
            {visible.map((r, idx, self) => (
              <SongLink
                dsps={dspsMap[r.url?.replace('/', '') ?? ''] ?? []}
                orderButtonsDisabledState={{
                  up: idx === 0,
                  down: idx === self.length - 1,
                }}
                key={r.id}
                data={r}
                artistName={pageData.title}
              />
            ))}
          </List>
        </ContentGrid>
        {!!hidden.length && (
          <ContentGrid noEditUI title="Hidden Releases">
            <List gap="small">
              {hidden.map((r) => (
                <SongLink
                  dsps={dspsMap[r.url?.replace('/', '') ?? ''] ?? []}
                  isHidden
                  key={r.id}
                  data={r}
                  artistName={pageData.title}
                />
              ))}
            </List>
          </ContentGrid>
        )}
      </HomeWrapperItems>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MusicPage);
